export const SCO = [
    "type",
    "id",
    "spec_version",
    "defanged",
    "extensions"
]